import { cn } from "@/shared/lib/utils";
import { useTranslation } from "react-i18next";

export function GlobalLoading({ className, size = 12, title, type = "full-screen" }: { className?: string, size?: number, title?: string, type?: "spinner" | "full-screen" }) {
    const { t } = useTranslation();
    return (
        <div className={cn(className, "flex items-center justify-center bg-color-basic-white", type === "full-screen" && "h-screen")}>
            <div className="flex flex-col items-center gap-4">
                <div className={cn("animate-spin rounded-full border-b-2 border-green-600", `size-${size}`)} />
                {title && <p className="text-grey-500">{t(title || "common.loading")}</p>}
            </div>
        </div>
    );
}
